<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $tc("add") }} {{ $tc("rating", 1) }}
      </div>
      <router-link class="btn-blue" to="ratings"
        >{{ $t("censor") }} {{ $tc("rating", 2) }}
        {{ $tc("list", 2) }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in Ratings"
          :key="index"
          v-if="item.fieldname !== 'rating_id'"
          class="col-lg-6 col-xl-3 align-self-center mb-4"
        >
          <div v-if="item.fieldname !== 'rating_is_active'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  style="text-align: right"
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  placeholder="."
                  v-b-tooltip.hover.top="$t(item.tooltip)"
                />
                <label>{{ $t("censor") }} {{ $tc(item.label, 1) }}</label>
              </div>
              <!-- <Tooltip :title="$t(item.tooltip)" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has(item.fieldname)">
                {{
                  item.type == "number"
                    ? $t(item.errormsg)
                    : errors.first(`${item.fieldname}`)
                }}
              </span>
            </p>
          </div>

          <div v-if="item.fieldname === 'rating_is_active'">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t("active") }}</label>
              <!-- <label class="ios-switch"> -->
              <b-form-checkbox
                type="checkbox"
                class="j-checkbox"
                v-model="item.fieldvalue"
              />
              <!-- <span class="switch-slider"></span>
              </label> -->
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="handleSubmit(true)"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="handleSubmit(false)"
            type="submit"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button class="btn-black" @click.prevent.stop="resetHandler()">
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="ratings">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Ratings from "@/helper/formJSONMaster/Ratings";

export default {
  data() {
    return {
      btenable: false,
      Ratings: Ratings.ms_ratings,
      // v-validate="'required|email'"
      submitted: false,
      Methods: Ratings.Methods,
    };
  },
  mounted() {
    console.log("Ratings :", Ratings);
    this.resetHandler();
  },
  methods: {
    onFocusHandler: function () {
      // this.submitted = false;
    },
    resetHandler: function () {
      this.Ratings.map((x) => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    handleSubmit(flag) {
      console.log("call submit :");
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        if (valid) {
          this.btenable = true;
          console.log("valid :", valid);
          let body = this.getRequestBody("POST", this.Ratings, this.Methods);
          console.log("body :", body);

          MasterService.GlobalRequest(body)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data.status) {
                console.log("here :", data);
                if (flag) {
                  this.$router.push({
                    path: "/master/ratings",
                  });
                } else {
                  this.resetHandler();
                }
              } else {
                this.$toasted.show(data.message);
                console.log("show error1 :", data.message);
              }
            })
            .catch((error) => {
              console.log("show error2 :", error);
            });
        } else {
          console.log("else :");
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/RatingsComponents/addRating.vue